import { render } from "./user-answer.vue?vue&type=template&id=2f04ad8b"
import script from "./user-answer.vue?vue&type=script&lang=js"
export * from "./user-answer.vue?vue&type=script&lang=js"

import "./user-answer.vue?vue&type=style&index=0&id=2f04ad8b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__